<template>
	<div class="login-body">
		<img :src="logoUrl" alt="" class="login-logo">
		<input class="com-input" type="text" v-model="account" placeholder="请输入手机号" @keyup.enter="loginFun()" style="margin-top: 1.3rem">
		<input class="com-input" type="password" v-model="password" placeholder="请输入密码" @keyup.enter="loginFun()">
		<div class="form-group" style="margin-top:.8rem">
			<button @click="loginFun()" class="button-login click" :class="{'disabled':loadState == 'loading'}" :disabled="loadState=='loading'">
				<p >登录</p>
				<!--<mt-spinner type="fading-circle" color="#ffffff" :size="20" v-show="loadState=='loading' " style="margin: auto;"></mt-spinner>-->
			</button>
		</div>

		<div class="forget click" @click="$router.push('/forget')">忘记密码</div>
	</div>
</template>
<script>
    import {mapActions} from 'vuex'
	import config from "@/config"
	export default{
		name:'login',
		created(){
			this.$store.state.showFooter = false;
		},
		data(){
			return {
				account:'',
				password:'',
				loadState:'finish',
				logoUrl: require("../../assets/images/logo_"+ config.projectName+".png")
			}
		},
		mounted(){
		    if(localStorage.loginMsg){
		        let msg = JSON.parse(localStorage.loginMsg)
				this.account = msg.ac
				this.password = msg.psw
			}
		},
		methods:{
            ...mapActions([
                'handleLogin',
                'getUserInfo'
            ]),
			loginFun: function() {
				if (!this.account) {
					this.$toast({message: '请输入手机号',position: 'bottom',duration: 1000});
					return false;
				}
				if (!this.password) {
					this.$toast({message: '请输入密码',position: 'bottom',duration: 1000});
					return false;
				} else {
					this.loadState = 'loading';
					let username = this.account;
					let password = this.password;
					let aliasName = config.projectName
					let auto = true;
                    this.handleLogin({username, password,aliasName, auto}).then(res => {
                        this.loadState = 'finish';
                        if(aliasName == 'changtong'){
							this.$router.push('/homeByToolCabinet');
						}else{
							this.$router.push('/home');
						}

                    }).finally(() =>{
                        this.loadState = 'finish';
                    })

				}
			},
		}
	}
</script>
<style lang="scss" scoped>
	.login-body{
		background: #fff;
		min-height: 100vh;
		padding-top: 1rem;
		position: relative;
	}
	.login-logo{
		width: 1.3rem;
		height: 1.3rem;
		background: #888888;
		display: block;
		margin: 0 auto;
	}
	.com-input{
		margin: 0 .6rem;
		padding: .25rem 0;
		border: none;
		border-bottom: .01rem solid #eee;
		font-size: .34rem;
		color: #333;
		line-height: .48rem;
		width: 6.3rem;
		display: block;
		&::-webkit-input-placeholder{
			color: #ccc;
		 }
	}
	.button-login{
		width: 6.3rem;
		margin: auto;
		background: $main-color;
		height: .94rem;
		text-align: center;
		line-height: .94rem;
		color: #fff;
		font-size: .36rem;
		border: none;
		border-radius: .1rem;
		display: block;
		&.disabled{
			opacity: .7;
		}
	}
	.forget{
		color: #999;
		font-size: .28rem;
		text-align: center;
		line-height: .4rem;
		margin-top: 2rem;
	}
</style>



// WEBPACK FOOTER //
// Login.vue?1a3b996e